/**
 * Priority ordered list of spec object slugs that should be used for top suggestions to create client side.
 * The priority order really only matters for a given spec + object type.
 * All objects slugs are merged into a single list for simplicity.
 */
export const topSpecObjectSlugs = [
  // DX, Elements
  'DX/Loading Indicator',
  'DX/Form Validation Error',
  'DX/Search Bar',
  'DX/Sign In Button',
  'DX/Contact Support Button',

  // DX, Events (Disabled)
  // 'DX/Home Page Visited',
  // 'DX/404 Page Viewed',
  // 'DX/JavaScript Error',
  // 'DX/Form Validation Error Seen',
  // 'DX/Loading Indicator Seen',
  // 'DX/Sign In Button Clicked',
  // 'DX/Chat Call to Action Clicked',

  // DX, Pages (Disabled)
  // 'DX/Home Page',
  // 'DX/404 Page',
  // 'DX/Sign In Page',

  // E-commerce, Elements
  'E-commerce/Add to Cart Button',
  'E-commerce/Checkout Button',
  'E-commerce/Search Bar',
  'E-commerce/View Cart Button',
  'E-commerce/Complete Order Button',
  'E-commerce/Coupon Input',
  'E-commerce/Applied Coupon',
  'E-commerce/Remove Coupon',
  'E-commerce/Out of Stock Notification',

  // E-commerce, Events (Disabled)
  // 'E-commerce/Cart Viewed',
  // 'E-commerce/Checkout Started',
  // 'E-commerce/Product Search Initiated',
  // 'E-commerce/Product Clicked',
  // 'E-commerce/Product Listing Page Viewed',
  // 'E-commerce/Product Listing Page Filtered',
  // 'E-commerce/Coupon Entered',
  // 'E-commerce/Coupon Applied',
  // 'E-commerce/Coupon Removed',

  // E-commerce, Pages (Disabled)
  // 'E-commerce/Checkout Page',
  // 'E-commerce/Order Confirmation',
  // 'E-commerce/Product Detail Page',
  // 'E-commerce/Product Listing Page',
  // 'E-commerce/Search Results',
];
